import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_tstkerjyhp: FaireBrandEntity = {
  token: "b_tstkerjyhp",
  type: "brand",
  name: "Merveille",
  avatarUrl:
    "https://cdn.faire.com/fastly/4a2e40b9be8a1390a15c7e3fbff6ff4f16b0c8fc7ad1d5f6b74c849a9fe52a7b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/79d385ec4b2c31d5a94a68d2f217417ceb6e2c5bdf96e1916dbabfec265fe269.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4a2e40b9be8a1390a15c7e3fbff6ff4f16b0c8fc7ad1d5f6b74c849a9fe52a7b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/79d385ec4b2c31d5a94a68d2f217417ceb6e2c5bdf96e1916dbabfec265fe269.jpeg",
  location: "Beverly Hills, CA, USA",
  minimumOrderDollars: 139,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Welcome to Merveille.\nJust like its name and foundations, our principle goal is to serve our customers with a dear heart and passion. With various accessories to choose from, feel free to shop unrestricted.\nThank you and enjoy!",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:56.429Z",
    importedBy: "entity-db-cli",
  },
};
